/** @file defineCommand: the one way to declare an edit command (name, description, zod input, apply). */
import type { z } from 'zod';
import type { Draft } from 'immer';
import type { Doc } from '@pose2d/format/types';
import type { CommandContext } from './commandContext';

export interface CommandDef<I> {
  /** `domain.verb`, e.g. `bone.create`. */
  name: `${string}.${string}`;
  /** One sentence shown to AI clients (MCP describe_command) and in the UI. */
  description: string;
  input: z.ZodType<I>;
  /** Synchronous, pure: mutates only `draft`; no IO, no randomness, no clock (use ctx). */
  apply(draft: Draft<Doc>, input: I, ctx: CommandContext): void;
}

/** Identity helper that pins the generic and documents intent; registries collect these. */
export function defineCommand<I>(def: CommandDef<I>): CommandDef<I> {
  return def;
}
